import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Imager from '../views/imager.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/imager',
    name: 'Imager',
    component: Imager
  },
  {
    path: '/pagina/:page',
    name: 'Page',
    component: () => import(/* webpackChunkName: "page" */ '../views/page.vue'),
    params: true
  },
  {
    path: '/dados',
    name: 'Dados',
    component: () => import(/* webpackChunkName: "dados-fs" */ '../views/dados.vue'),
  },
  {
    path: '/rank-fs',
    name: 'RankFs',
    component: () => import(/* webpackChunkName: "rank-fs" */ '../views/rank_fs.vue'),
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
